import { length, prop } from 'ramda';
import { noParamsReducer, toSuccess } from 'react-async-client';

import {
    GET_APPROVAL_PERSON_COUNTERS,
    APPROVE_PERSON,
    REJECT_PERSON,
    GET_APPROVAL_PROJECT_COUNTERS,
    APPROVE_PROJECT,
    REJECT_PROJECT,
    LOGOUT,
    GET_NOTDONE_LIST
} from 'constants/actionTypes';

const menuCountersCustomReducer = (state, { type, payload }) => {
    const { person, project } = state;
    const counts = length(prop('ids', payload || {}));

    switch(type) {
        case APPROVE_PERSON:
        case REJECT_PERSON:
            return { ...state, person: { inwork: person.inwork - counts } };
        case toSuccess(GET_APPROVAL_PERSON_COUNTERS):
            return { ...state, person: { inwork: payload.inwork }};
        case REJECT_PROJECT:
        case APPROVE_PROJECT:
            return { ...state, project: { inwork: project.inwork - counts } };
        case toSuccess(GET_APPROVAL_PROJECT_COUNTERS):
            return { ...state, project: { inwork: payload.inwork }};
        case toSuccess(GET_NOTDONE_LIST):
            return { ...state, notdone: { count: payload.linesTotal } };
        case LOGOUT:
            return {};
        default:
            return state;
    }
}

export const menuCountersReducer = noParamsReducer(
    menuCountersCustomReducer, [
        LOGOUT,
        toSuccess(GET_APPROVAL_PERSON_COUNTERS),
        APPROVE_PERSON,
        REJECT_PERSON,
        toSuccess(GET_APPROVAL_PROJECT_COUNTERS),
        APPROVE_PROJECT,
        REJECT_PROJECT,
        toSuccess(GET_NOTDONE_LIST)
    ]
);
